/* eslint-disable no-debugger */
import { useEffect, useState } from "react";

import useBaseUsasClubData from "@usas/ui-web/state/clubBase/UseBaseUsasClubData";
import useSecurityData from '@usas/ui-web/state/security/UseSecurityData';

import useUsasClubFacilityLinksData from '../../../../../state/clubFacilityLinks/UseUsasClubFacilityLinksData';
import useMeetFormatData from "../../../../../state/meetFormat/UseMeetFormatData";
import useMeetSanctionConfigurationData from "../../../../../state/meetSanctionConfiguration/UseMeetSanctionConfigurationData";

import Constants from "@usas/ui-web/utils/Constants";

import { formatDate } from '@usas/ui-web/utils/DateFunctions';

const USAS_SANCTION_TEXT = 'This meet will be sanctioned through USA Swimming. By checking this box, you are agreeing to follow all USA Swimming sanctioning rules and guidelines.';
const LSC_SANCTION_TEXT = 'This meet will be sanctioned through your Local Swimming Committee (LSC). By checking this box, you are agreeing to follow all LSC sanctioning rules and guidelines. The meet will have a Pending status until it is approved by your LSC. Please check with your LSC for their sanctioning process and timelines.';

const UseMeetSanctionInfoFormV3 = ({
  formState,
  setFormState,
  savedFormState,
  setIsDirty,
  meetState,
  hasUsasSanctionAccess
}) => {
  const { baseUsasClubState } = useBaseUsasClubData();
  const { usasClubFacilityLinksState, getUsasClubFacilityLinks, clearUsasClubFacilityLinksArrayData } = useUsasClubFacilityLinksData();
  const { meetSanctionConfigurationState, getMeetSanctionConfiguration } = useMeetSanctionConfigurationData();

  const { meetFormatState, getMeetFormats } = useMeetFormatData();
  const [modalState, setModalState] = useState(getInitialModalState());
  const { securityState } = useSecurityData();

  const onModalCancelClicked = () => {
    setModalState({
      ...getInitialModalState()
    });

    if (formState.depthRequirementMet === false && formState.isInWaterStart === false) {
      setFormState({
        ...formState, facilityId: Constants.DEFAULT_ID
      })
    }
  }

  function getFacilityById(facilityId) {
    return (usasClubFacilityLinksState.arrayData || []).find(
      x => x.facilityId === facilityId || x.facility?.facilityId === facilityId
    )?.facility;
  }

  function checkFacilityPoolDepthRequirement(facilityId) {
    const facility = getFacilityById(facilityId);

    if (!facility) {
      return false;
    }

    let requirementMet = false;

    if (meetState.isObjLoaded === true) {
      requirementMet = facility.depthRequirementMet || meetState.objData.isInWaterStart;
    } else {
      requirementMet = facility.depthRequirementMet || formState.isInWaterStart;
    }

    return requirementMet;
  }

  useEffect(() => {
    getMeetSanctionConfiguration(6);

    clearUsasClubFacilityLinksArrayData();

    if (meetFormatState.isArrayLoading !== true && meetFormatState.isArrayLoaded !== true) {
      getMeetFormats();
    }

    setFormState(prev => ({
      ...prev,
      ...savedFormState,
      autogeneratedMeetLsc: baseUsasClubState?.objData?.orgUnit?.parentOrgUnitCode || ''
    }));

    setIsDirty(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {

    if (meetState.isObjLoaded === true && savedFormState.meetId > 0 && formState.meetId < 0) {
      const selMeetClassification = [];

      if (meetState.objData?.meetClassification !== undefined) {
        selMeetClassification.push({ id: meetState.objData.meetClassification.meetClassificationId, name: meetState.objData.meetClassification.typeName });
      }

      const facilityId = meetState.objData?.facilityId || savedFormState.facilityId || Constants.DEFAULT_ID;
      const facilityNameFromLinks = getFacilityById(facilityId)?.facilityName || '';
      const facilityName = meetState.objData?.facility?.facilityName || savedFormState.facilityName || facilityNameFromLinks;

      const selMeetCourse = [];
      if (meetState.objData?.meetCourse !== undefined) {
        selMeetCourse.push({ id: meetState.objData.meetCourse[0].course.courseId, name: meetState.objData.meetCourse[0].course.courseCode });
      }

      if (meetState.objData?.meetCourse !== undefined && meetState.objData.meetCourse.length > 1) {
        selMeetCourse.push({ id: meetState.objData.meetCourse[1].course.courseId, name: meetState.objData.meetCourse[1].course.courseCode });
      }

      if (meetState.objData?.meetCourse !== undefined && meetState.objData.meetCourse.length > 2) {
        selMeetCourse.push({ id: meetState.objData.meetCourse[2].course.courseId, name: meetState.objData.meetCourse[2].course.courseCode });
      }

      const geographicFacilityLscOrgUnitId = meetState.objData?.geographicSanctionOrgUnitId || savedFormState.geographicFacilityLscOrgUnitId || Constants.DEFAULT_ID;
      const meetSoftwareId = meetState.objData?.meetSoftwareId || savedFormState.meetSoftwareId || Constants.DEFAULT_ID;
      const meetFormatId = meetState.objData?.meetFormatId || savedFormState.meetFormatId || Constants.DEFAULT_ID;
      const attestationSignature = savedFormState.attestationSignature || '';

      setFormState(prev => ({
        ...prev,
        ...savedFormState,
        startDate: savedFormState.startDate ? formatDate(savedFormState.startDate) : Constants.BLANK_DATE_STRING,
        endDate: savedFormState.endDate ? formatDate(savedFormState.endDate) : Constants.BLANK_DATE_STRING,
        startDateOriginal: savedFormState.startDate ? formatDate(savedFormState.startDate) : Constants.BLANK_DATE_STRING,
        endDateOriginal: savedFormState.endDate ? formatDate(savedFormState.endDate) : Constants.BLANK_DATE_STRING,
        meetClassification: selMeetClassification,
        meetCourse: selMeetCourse,
        facilityId: facilityId,
        facilityName: facilityName,
        geographicFacilityLscOrgUnitId: geographicFacilityLscOrgUnitId,
        meetSoftwareId: meetSoftwareId,
        meetFormatId: meetFormatId,
        attestationSignature: attestationSignature,
        hasUsasSanctionAccess: hasUsasSanctionAccess,
        payorMemberId: meetState.objData?.payorMemberId || savedFormState.payorMemberId || '',
        payorPersonId: meetState.objData?.payorPersonId || savedFormState.payorPersonId || Constants.DEFAULT_ID,
        thisIsMe: savedFormState.payorMemberId === securityState?.userInfo?.memberId || false,
        status: meetState.objData?.status || ''
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedFormState, meetState, usasClubFacilityLinksState.arrayData]);

  useEffect(() => {
    if (baseUsasClubState.isObjLoading === false && baseUsasClubState.isObjLoaded === true
      && usasClubFacilityLinksState.isArrayLoaded === false 
      && usasClubFacilityLinksState.isArrayLoading === false) {
      getUsasClubFacilityLinks(baseUsasClubState.objData.usasClubId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseUsasClubState, usasClubFacilityLinksState]);

  useEffect(() => {
    if (formState.facilityId > 0) {
      let metRequirement = false;
      metRequirement = checkFacilityPoolDepthRequirement(formState.facilityId);
      const facilityName = getFacilityById(formState.facilityId)?.facilityName || '';

      setModalState({
        ...modalState,
        displayModal: !metRequirement,
        facilityName: facilityName
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formState.facilityId, usasClubFacilityLinksState.arrayData]);

  useEffect(() => {
    if (meetSanctionConfigurationState.isObjLoaded === true) {
      setFormState(prev => ({
        ...prev,
        pilotStartDate: meetSanctionConfigurationState.objData.startDate ? formatDate(meetSanctionConfigurationState.objData.startDate) : Constants.BLANK_DATE_STRING,
        pilotEndDate: meetSanctionConfigurationState.objData.endDate ? formatDate(meetSanctionConfigurationState.objData.endDate) : Constants.BLANK_DATE_STRING
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetSanctionConfigurationState]);

  function getInitialModalState() {
    return {
      displayModal: false,
      facilityName: ''
    }
  }

  return {
    meetFormatState,
    modalState,
    meetSanctionConfigurationState,
    usasClubFacilityLinksState,
    onModalCancelClicked,
    USAS_SANCTION_TEXT,
    LSC_SANCTION_TEXT
  };
};

export default UseMeetSanctionInfoFormV3;